import React from 'react'

import MenuResponsive from './components/MenuResponsive'
import Menu from './components/Menu'

class MenuCustom extends React.Component {
  state = {
    docked: null
  }

  componentDidMount() {
    const mql = window.matchMedia(`(min-width: 800px)`)
    mql.addListener(this.mediaQueryChanged)
    this.setState({ docked: mql.matches })
  }

  componentWillUnmount() {
    const mql = window.matchMedia(`(min-width: 800px)`)
    mql.removeListener(this.mediaQueryChanged)
  }

  mediaQueryChanged = () => {
    const mql = window.matchMedia(`(min-width: 800px)`)
    this.setState({ docked: mql.matches })
  }

  render() {
    const { docked } = this.state
    const { routes } = this.props

    return (
      <>
        {docked ? (
          <Menu routes={routes} />
        ) : (
          <MenuResponsive routes={routes} isOpen={docked} />
        )}
      </>
    )
  }
}

export default MenuCustom
